﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orders = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
const models_3 = require("./models");
class Orders {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * Get orders. Allowed:[Driver]
    * @returns {Promise<ResultFail|Array<OrderExtended>|net.NetError|number>}
    */
    byQueryUnsafe(fromTimeUTC, toTimeUTC, skip, take, onlyActive, onlyPast, state) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/ByQuery";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("fromTimeUTC=" + encodeURIComponent(fromTimeUTC));
            __query.push("toTimeUTC=" + encodeURIComponent(toTimeUTC));
            __query.push("skip=" + encodeURIComponent(skip));
            __query.push("take=" + encodeURIComponent(take));
            __query.push("onlyActive=" + encodeURIComponent(onlyActive));
            __query.push("onlyPast=" + encodeURIComponent(onlyPast));
            __query.push("state=" + encodeURIComponent(state));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.OrderExtended(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get orders. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<OrderExtended>>}
    */
    byQuery(fromTimeUTC, toTimeUTC, skip, take, onlyActive, onlyPast, state, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.byQueryUnsafe(fromTimeUTC, toTimeUTC, skip, take, onlyActive, onlyPast, state);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Get orders. Allowed:[UserId=order.DriverId]
    * @returns {Promise<ResultFail|OrderExtended|net.NetError|number>}
    */
    byIdUnsafe(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/ById";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("orderId=" + encodeURIComponent(orderId));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.OrderExtended(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get orders. Allowed:[UserId=order.DriverId]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<OrderExtended>}
    */
    byId(orderId, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.byIdUnsafe(orderId);
                if (!(r instanceof models_1.OrderExtended))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    hotUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/Hot";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_3.Order(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get hot offered for driver active orders. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<Order>>}
    */
    hot(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.hotUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    delayedUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/Delayed";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.OrderExtended(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get delayed untaked active orders. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<OrderExtended>>}
    */
    delayed(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.delayedUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    myActiveUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/MyActive";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_3.Order(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get active orders. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<Order>>}
    */
    myActive(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.myActiveUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Take order. Allowed:[Driver]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    takeActiveUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/TakeActive";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_3.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Take order. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    takeActive(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.takeActiveUnsafe(body);
                if (!(r instanceof models_3.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Untake order for driver. Allowed:[Driver]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    untakeActiveUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/UntakeActive";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_3.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Untake order for driver. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    untakeActive(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.untakeActiveUnsafe(body);
                if (!(r instanceof models_3.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Change active order state. Allowed:[Driver]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    changeActiveStateUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/ChangeActiveState";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_3.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Change active order state. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    changeActiveState(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.changeActiveStateUnsafe(body);
                if (!(r instanceof models_3.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Cancel order.
    * @returns {Promise<ResultFail|OrderExtended|net.NetError|number>}
    */
    cancelUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Orders/Cancel";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.OrderExtended(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Cancel order.
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<OrderExtended>}
    */
    cancel(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.cancelUnsafe(body);
                if (!(r instanceof models_1.OrderExtended))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.Orders = Orders;
//# sourceMappingURL=Orders.js.map